module.exports = __webpack_public_path__ + "static/hero-fa348c08f83e2d7a89446a9b7bf61443.jpg";